import React from "react";
import Tooltip from "../Tooltip/Tooltip";
import "./ActionButtons.css";

/**
 * ActionButtons Component
 * 
 * A reusable container for standardized icon-based action buttons.
 * 
 * @param {Array} actions - Array of action objects: { label, icon, onClick, variant, disabled, hidden }
 * @param {string} className - Optional additional class for the container
 */
const ActionButtons = ({ actions = [], className = "" }) => {
    const visibleActions = actions.filter(action => !action.hidden);

    if (visibleActions.length === 0) return null;

    return (
        <div className={`action-buttons-group ${className}`}>
            {visibleActions.map((action, index) => {
                const btn = (
                    <button
                        className={`action-btn ${action.variant || ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (action.onClick) action.onClick();
                        }}
                        disabled={action.disabled}
                        title={!action.tooltip ? action.label : undefined}
                    >
                        {typeof action.icon === 'string' ? (
                            <i className={action.icon}></i>
                        ) : (
                            action.icon
                        )}
                    </button>
                );

                if (!action.tooltip) {
                    return <React.Fragment key={index}>{btn}</React.Fragment>;
                }

                return (
                    <Tooltip
                        key={index}
                        text={typeof action.tooltip === 'string' ? action.tooltip : action.label}
                        position={action.tooltipPosition || "top"}
                    >
                        {btn}
                    </Tooltip>
                );
            })}
        </div>
    );
};

export default ActionButtons;
